import { Button, Checkbox, Divider, Input, message, Modal, Popconfirm, Popover, Select, Switch } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import './InputFields.css';
import { Col, Label, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheck, faDollarSign, faFile, faHashtag, faKeyboard, faList, faPhone, faPlus, faTimes, faUser, faUserCog } from '@fortawesome/free-solid-svg-icons';
import OptionCards from './OptionCards';
import { values } from 'lodash';
import swal from 'sweetalert'
import { QuestionCircleOutlined } from '@ant-design/icons';
import { AppDataRequired } from '../../App';
import { FolderPicker } from '../FolderPicker/FolderPicker';
import { FolderTemplate } from '../FolderPicker/Tree/ActionConst';
import HashTagInput, { NamingConvPopup } from '../NamingConvention/HashTagInput';
import { InputFieldIcon } from './IconPack';

export const InputFields = ({
    // open,
    // setOpen,
    accessType='write',
    setSelectInputField,
    selectInputField,
    Module,
    onSave,
    cardSize,
    children,
    onAdd,
    taskData
}) => {
    const { DealFields } = useContext(AppDataRequired);
    const appDataContext = useContext(AppDataRequired);
    // console.log("Deal-Fields",DealFields.map(k=>({field:k.field,id:k.id,name:k.name})));

    const [DealInputFields,setDealInputFields] = useState([]);
    const [validation,setValidation] = useState(false); 
    const [error, setError] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [options,setOptions] = useState([]);
    useEffect(e => {
        if (appDataContext.DealFields) {
            let arr = [...appDataContext.DealFields];
            arr.unshift({id:"__1",field:"Actual_Name",name:"Actual Name Of File"})
            setOptions(arr)
        }
    }, [appDataContext.DealFields])
    const [openFolderPicker,setOpenFolderPicker] = useState(false);
    const [isSelectOpen, setSelectOpen] = useState(false);
    const [isSelectOpenForPrecision, setSelectOpenForPrecision] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [open,setOpen]=useState(false);
    const handleSelectClick = (open) => {
        // Show confirmation dialog only when the select dropdown is closed
        if (!isSelectOpen && open && inputField.Type == "PICKLIST") {
            setConfirmVisible(true);
        } else {
            setSelectOpen(open); // Allow closing the dropdown normally
        }
    };
    const handleSelectClickForPrecision = (open) => {
        // Show confirmation dialog only when the select dropdown is closed
        if (!isSelectOpenForPrecision && open && inputField.Type == "NUMBER") {
            setSelectOpenForPrecision(true);
        } else {
            setSelectOpenForPrecision(open); // Allow closing the dropdown normally
        }
    };

    const handleConfirm = () => {
        setConfirmVisible(false); // Hide the Popconfirm
        setSelectOpen(true);   // Open the select dropdown
    };
    function onCloseCallBack(){
        if(setSelectInputField){
            setSelectInputField(null);
        }
        setInputField({...inputFieldTemplate})
        setSelectOpen(false);
        // setAttachmentPath(FolderTemplate);
        setSelectOpenForPrecision(false);
    }
    // useEffect(e=>{
    //     if(!open){
    //         setSelectOpen(false);
    //         setSelectOpenForPrecision(false);
    //     }
    // },[open])
    useEffect(()=>{
    if(!open){
        setValidation(false)
    }
    },[open])

    const handleCancel = () => {
        setConfirmVisible(false);  // Hide the Popconfirm without opening the dropdown
    };
    const inputFieldTemplate = {
        id:Date.now(),
        Name: "",
        Description: "",
        Mandatory:false,
        Module: Module ,
        Type: "TEXT",
        ExtraData: [],
        Precision:"0",
        AttachmentPath:[],
        isDuplicate:false
    }
    // let AttachmentPathTemp=[
    //     {
    //         type: "folder",
    //         readOnly: true,
    //         name: "Deal Directory",
    //         files: [],
    //     },
    // ];
    const [inputField, setInputField] = useState({ ...inputFieldTemplate })
    const [AttachmentPath,setAttachmentPath] = useState(FolderTemplate)
    // useEffect(e => {
    //      
    // }, [inputField])
    useEffect(e=>{
        if(selectInputField && selectInputField.type=="edit" && selectInputField.data){
            setInputField(selectInputField.data);
            // if(selectInputField?.data?.AttachmentPath){
            //     setAttachmentPath(selectInputField?.data?.AttachmentPath)
            // }
            setOpen(true);
        }
    },[selectInputField])
    const [types, setTypes] = useState([...InputFieldIcon])
    const [significantDigits, setSignificantDigits] = useState([
        {
            label: "0",
            value: "1",
        },
        {
            label: ".0",
            value: ".1",
        },
        {
            label: ".00",
            value: ".01",
        },
        {
            label: ".000",
            value: ".001",
        },
        {
            label: ".0000",
            value: ".0001",
        },
        {
            label: ".00000",
            value: ".00001",
        },
    ])
    function toggleSection(e) {
        setToggle(e)
    }
    function modifyData(data) {
        return new Promise((resolve, reject) => {
            const removeParentKey = (arr) => {
                return arr.map(k => {
                    const cloned = { ...k };
                    delete cloned["parent"];
                    if (cloned.files) {
                        cloned.files = removeParentKey(cloned.files);
                    }
                    return cloned;
                });
            };
            let arr = removeParentKey(data);
            resolve(arr);
        });
    }
  async function onChangeInputField(key, value) {
    let obj = { ...inputField };
 
    if (key === "Type") {
        const wasPicklist = obj.Type === "PICKLIST" || obj.Type === "MULTI-PICKLIST";
        const isPicklist = value === "PICKLIST" || value === "MULTI-PICKLIST";
 
        // Agar type picklist se picklist (ya multi-picklist) me change ho raha hai, options ko preserve karo
        if (wasPicklist && isPicklist) {
            // ExtraData ko reset mat karo, options waise hi rehne do
        }
        // Agar picklist se kisi aur type me ja rahe hain to options clear kar do
        else if (wasPicklist && !isPicklist) {
            obj["ExtraData"] = [];
        }
 
        // Agar new type attachment nahi hai to AttachmentPath clear karo
        if (value !== "ATTACHMENT") {
            obj["AttachmentPath"] = [];
        }
        // Agar new type number nahi hai to Precision reset karo
        if (value !== "NUMBER") {
            obj["Precision"] = "0";
        }
    }
 
    obj[key] = value;
    setInputField(obj);
}
 

    return (
        <Popover
            title={"CREATE INPUT FIELD"}
            placement="left"
            // arrowPointAtCenter
            open={open}
            onOpenChange={e=>{
                if(!openFolderPicker){
                    if(!e){
                        onCloseCallBack()
                    }
                    setOpen(e)
                }
            }}
            className='Input-Field-Popover-Main'
            overlayClassName='Input-Field-Popover'
            destroyTooltipOnHide
            trigger={"click"}
            content={
                 open && <div className='Input-Field-Wrapper'>
                    {<FolderPicker
                        value={inputField?.AttachmentPath}
                        open={openFolderPicker}
                        setOpen={setOpenFolderPicker}
                        onChange={(data) => {
                            // modifyData(data).then(res => {
                                onChangeInputField("AttachmentPath", data)
                            // })
                        }}
                    />}
                    {/* <div className='container' sm={12}>
                        {createdFields && createdFields.map(field => {
                            return <div className='Card'>
                                {field.Type == "PICKLIST" ? <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faList} />
                                    : <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faKeyboard} />}
                                {field.Name}
                                <FontAwesomeIcon className='Close-Icon' style={{ "margin-right": "7px" }} icon={faTimes} />
                            </div>
                        })}
                        <div className='Card Add-Icon'>
                            <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
                            {"Add"}
                        </div>
                    </div>
                    <Divider /> */}
                    <div className='Create-Input-Fields-Section' id="inputSection">
                        <Row sm={12}>
                            <Col className={"mb-3 mt-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Name</Label>
                                </span> 
                                <Input
                                    className='Global-Text-Color'
                                    // disabled={bluePrintData?.lock=="true"}
                                    // className="input" 
                                    value={inputField?.Name}
                                    onChange={(e) => {
                                        e.currentTarget.value=e.currentTarget.value.trimStart();
                                        if(e.currentTarget.value==''){
                                            setValidation(true)
                                        }else{
                                            setValidation(false)
                                        }
                                        onChangeInputField("Name", e.currentTarget.value)
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row sm={12}>
                            <Col className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Description</Label>
                                </span>
                                <Input
                                    className='Global-Text-Color'
                                    // disabled={bluePrintData?.lock=="true"}
                                    // className="input"
                                    // value={selectedData?.data?.data?.label}
                                    value={inputField?.Description}
                                    onChange={(e) => {
                                        e.currentTarget.value=e.currentTarget.value.trimStart();
                                        onChangeInputField("Description", e.currentTarget.value)
                                    }}
                                />
                            </Col>
                        </Row>
                        {/* <Row sm={12}>
                            <Col style={{    display: "flex",color: "#5a6c97"}} className={"mb-3"} sm={12}>
                             
                                Mandatory
                                <Input
                                    style={{width: "max-content","margin-left": "10px"}}
                                    type='checkbox'
                                    className='Global-Text-Color'
                                 
                                    checked={inputField?.Mandatory}
                                    onChange={(e) => {
                                        onChangeInputField("Mandatory", e.currentTarget.checked)
                                    }}
                                />
                            </Col>
                        </Row> */}
                        <Divider />
                        <Row sm={12}>
                            <Col className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Type</Label>
                                </span>
                                <Popconfirm
                                    // disabled={inputField.Type != "PICKLIST"}
                                    open={confirmVisible}
                                    onConfirm={handleConfirm}
                                    onCancel={handleCancel}
                                    okText="Ok"
                                    cancelText="Cancel"
                                    title="Change Input Type"
                                    description="Options are going to erase."
                                    icon={
                                        <QuestionCircleOutlined
                                            style={{
                                                color: 'red',
                                            }}
                                        />
                                    }
                                >
                                    <Select
                                        // style={{color:"#5b6c97"}}
                                        className='Global-Text-Color'
                                        showSearch
                                        placeholder="Select type"
                                        open={isSelectOpen}
                                        onDropdownVisibleChange={handleSelectClick}
                                        // options={types}
                                        value={inputField?.Type}
                                        onSelect={(value, option) => {
                                            onChangeInputField("Type", value)
                                        }}
                                    >
                                       {types.map((option,i)=> (<Select.Option className='Global-Text-Color' value={option.value}>
                                            {option?.icon && option.icon}{option.label}
                                        </Select.Option>))}
                                    </Select>
                                </Popconfirm>

                            </Col>
                        </Row>
                        {(inputField?.Type == "PICKLIST" || inputField?.Type == "MULTI-PICKLIST") && <Row style={{ height: "123px", overflow: "scroll" }}>
                            <OptionCards inputField={inputField} setInputField={setInputField}></OptionCards>
                        </Row>}
                        {(inputField?.Type == "ATTACHMENT") && <Row sm={12}>
                            <Col 
                            // style={{
                            //     minHeight: "auto",
                            //     maxHeight: "10em",
                            //     overflow: "scroll",
                            // }} 
                            onClick={e=>{
                                setOpenFolderPicker(true);
                            }}
                            className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Attachment path</Label>
                                </span>
                                <Input className="Global-Text-Color" placeholder='Select the path' value={inputField?.AttachmentPath?.path} readOnly={true} onClick={e => {
                                    setOpenFolderPicker(true);
                                }} />
                            </Col>
                        </Row>}
                        {(inputField?.Type == "ATTACHMENT") && <Row sm={12}>
                            <Col 
                            // style={{
                            //     minHeight: "auto",
                            //     maxHeight: "10em",
                            //     overflow: "scroll",
                            // }} 
                            // onClick={e=>{
                            //     setOpenFolderPicker(true);
                            // }}
                            className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Attachment name</Label>
                                </span>
                                <HashTagInput
                                    value={inputField?.NameFormat}
                                    setValue={val=>{
                                        onChangeInputField("NameFormat", val)
                                    }}
                                    options={options}
                                    triggerChar={"{"}
                                />
                            </Col>
                        </Row>}
                        {inputField?.Type == "NUMBER" && <Row sm={12}>
                            <Col className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Precision</Label>
                                </span>
                                <Select
                                    // style={{color:"#5b6c97"}}
                                    className='Global-Text-Color'
                                    showSearch
                                    placeholder="Select type"
                                    open={isSelectOpenForPrecision}
                                    onDropdownVisibleChange={handleSelectClickForPrecision}
                                    options={significantDigits}
                                    value={inputField?.Precision}
                                    onSelect={(value, option) => {
                                        onChangeInputField("Precision", value)
                                    }}
                                ></Select>

                            </Col>
                        </Row>}
                        
                        {/* {inputField?.Type == "NUMBER" && <Row style={{ height: "156px", overflow: "scroll" }}>
                            <Select
                                // style={{color:"#5b6c97"}}
                                className='Global-Text-Color'
                                showSearch
                                placeholder="Select type"
                                open={isSelectOpenForPrecision}
                                onDropdownVisibleChange={handleSelectClickForPrecision}
                                options={significantDigits}
                                value={inputField?.Type}
                                onSelect={(value, option) => {
                                    onChangeInputField("Type", value)
                                }}
                            ></Select>
                        </Row>} */}
                        {/* <Divider /> */}
                        <Row style={{ display: "flex", justifyContent: "flex-end", padding: "5px" }}>
                            {validation && <small style={{width: 'auto',position: 'relative',right: '10em',color: 'red'}}> Name should not be empty.</small>}
                            <Button style={{ width: "auto", padding: "6px" }} className='mr-1'
                                onClick={e=>{
                                    onCloseCallBack() 
                                    // setInputField(inputFieldTemplate);
                                    setOpen(false)
                                }}
                            >Cancel</Button>
                            <Button type='primary' style={{ width: "auto", padding: "6px" }} 
                            className='ml-1'
                            onClick={e => {
                                const taskData1 = taskData;
                                const fixedInput = !!taskData?.TaskFlowObject?.InputFields.find(inp => inp.Name.toLowerCase() == inputField.Name.toLowerCase());
                                const inp = !!taskData1?.InputFields?.find(inp => inp.Name.toLowerCase() == inputField.Name.toLowerCase());
                                const isFieldPresent = appDataContext.DealFields.some(
                                        (dealField) => dealField.field.toLowerCase() === inputField.Name.toLowerCase()
                                    );
                                    if(accessType=="read"||accessType=='none'){
                                    message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                                    return;
                                    }
                                    if (inputField.Name === '') {
                                        setValidation(true);
                                        return;
                                    }
                                    if ((inputField.Type === 'PICKLIST' || inputField.Type === 'MULTI-PICKLIST') && (!inputField.ExtraData || inputField.ExtraData.length === 0)) {
                                        swal("Please add at least one option.");  
                                        return;
                                    }
                                    if (inp || isFieldPresent || fixedInput) {
                                        inputField.isDuplicate = true;
                                    }
                                    onAdd(inputField, selectInputField?.type);
                                    setInputField(inputFieldTemplate);
                                    onCloseCallBack();
                                    setOpen(false);
                                }} 
                            >Save</Button>
                        </Row>
                    </div>
                    {/* {Module=="TASK" && <div className='Create-Input-Fields-Section' id="inputSection"> 
                        <Row sm={12}>
                            <Col className={"mb-3"} sm={12}>
                                <span className="labeltext">
                                    <Label>Deal Fields</Label>
                                </span>
                                    <Select
                                        mode='multiple'
                                        // style={{color:"#5b6c97"}}
                                        className='Global-Text-Color'
                                        showSearch
                                        placeholder="Select type"
                                        open={isSelectOpen}
                                        onDropdownVisibleChange={handleSelectClick}
                                        // options={types}
                                        value={DealInputFields}
                                        onChange={(value, option) => {
                                            setDealInputFields(value)
                                        }}
                                    >
                                       {DealFields && DealFields.map((option,i)=> (<Select.Option className='Global-Text-Color' value={option.id}>
                                            {option.name}
                                        </Select.Option>))}
                                    </Select>
                            </Col>
                        </Row>
                        <Row style={{ display: "flex", justifyContent: "flex-end", padding: "5px" }}>
                            <Button style={{ width: "auto", padding: "6px" }} className='mr-1'
                                onClick={e=>{
                                    onCloseCallBack() 
                                    setOpen(false)
                                }}
                            >Cancel</Button>
                            <Button type='primary' style={{ width: "auto", padding: "6px" }} className='ml-1'
                                onClick={e=>{
                                    if(module=="TASK" && DealInputFields?.length>0 && false){
                                        // DealFields.forEach(element => {
                                        //     let obj={...inputFieldTemplate};
                                        //     if(DealInputFields.includes(element.id)){
                                        //         obj.Type = element.type;
                                        //         obj.id = element.id;
                                        //         obj.Name = element.name;
                                        //         onAdd(obj,selectInputField?.type);
                                        //     }
                                        // });
                                    }else{
                                        onAdd(inputField,selectInputField?.type);
                                    }
                                    setInputField(inputFieldTemplate);
                                    onCloseCallBack()
                                    setOpen(false)
                                }}
                            >Save</Button>
                        </Row>
                    </div>} */}
                </div>
            }
        >
            {children}
        </Popover>
    )
}
